import axios from "axios";
import { useState } from "react";
import { NavLink } from "react-router";

const AddOne = () => {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleIncrement = async () => {
    try {
      setLoading(true);
      const response = await axios.get("/api/v1/add-one?number=" + count);
      setCount(response.data.result);
      setLoading(false)
    } catch (error) {
      setLoading(false);
      console.error("Error incrementing the count:", error);
    }
  };

  return (
    <div>
      <h1>Count: {count}</h1>
      <button disabled={loading} onClick={handleIncrement}>
        {loading ? "Loading..." : "+1"}
      </button>

      <NavLink to="/" end>
        Home
      </NavLink>
    </div>
  );
};

export default AddOne;
